module.exports = __webpack_public_path__ + "static/media/happy5.06dfdf6e.svg";